import { STORAGE_KEY } from '@/constants/storage';
import { $http } from '@/plugins/common/http';

export const getNotificationsList = (query) => {
    return $http.get('/user/notification/me', {
        params: {
            ...query,
        },
        headers: { [STORAGE_KEY.CACHE_CONTROL]: 'no-cache' },
    });
};
export const readNotification = (id) => {
    return $http.put('user/notification/read/' + id);
};

export const countUnreadNotification = () => {
    return $http.get('/notification/count-unread/', {
        headers: { [STORAGE_KEY.CACHE_CONTROL]: 'no-cache' },
    });
};
